import styled, { css } from 'styled-components';

import { DropAreaStyledProps } from '@/ui/DropArea/types';

export const RootStyled = styled.div`
  width: 100%;
`;

const dragActiveCSS = css`
  border-color: ${(p) => p.theme.colors.primary.main};
  background-color: ${(p) => p.theme.colors.states.hover6};
`;

export const DropAreaStyled = styled.button<DropAreaStyledProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 50px 34px;
  border: 2px dashed ${(p) => p.theme.colors.neutral.outline1};
  border-radius: 8px;
  background-color: ${(p) => p.theme.tones.neutral[99]};
  font: inherit;
  color: inherit;
  text-align: center;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${(p) => p.theme.colors.neutral.outline2};
  }

  /* The area is a custom control, so it does not inherit the design system focus ring */
  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primary.outline};
    outline-offset: 2px;
  }

  &:disabled {
    border-color: ${(p) => p.theme.colors.neutral.disabled};
    color: ${(p) => p.theme.colors.neutral.disabled};
    cursor: not-allowed;
  }

  ${({ $dragActive }) => $dragActive && dragActiveCSS}
`;
